// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';

export const SignInDynamic = dynamic(() => import('./SignIn').then(module => module.SignInEditable));
export { SignInEditable } from './SignIn';
export { SignIn } from './SignIn';
